var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg001Appetizer = function Svg001Appetizer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m347.099 328.021h114.719v35.325h-114.719z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.498 296.588h85.921v31.433h-85.921z",
    fill: "#00e0a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.099 265.827h114.719v30.761h-114.719z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 404.459,
    cy: 225.803,
    fill: "#ff2f6b",
    rx: 40.024,
    ry: 40.024,
    transform: "matrix(.276 -.961 .961 .276 75.904 552.339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.783 328.021h18.035v35.325h-18.035z",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.384 296.588h18.035v31.433h-18.035z",
    fill: "#00c988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.783 265.827h18.035v30.761h-18.035z",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.459 185.78c-3.103 0-6.118.365-9.018 1.033 17.759 4.092 31.006 19.989 31.006 38.991s-13.246 34.899-31.006 38.991c2.9.668 5.915 1.033 9.018 1.033 22.104 0 40.024-17.919 40.024-40.024s-17.919-40.024-40.024-40.024z",
    fill: "#f3155e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.632 328.021h114.719v35.325h-114.719z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.031 296.588h85.921v31.433h-85.921z",
    fill: "#00e0a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.632 265.827h114.719v30.761h-114.719z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.992,
    cy: 225.803,
    fill: "#ff2f6b",
    rx: 40.024,
    ry: 40.024,
    transform: "matrix(.383 -.924 .924 .383 -50.587 375.898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.316 328.021h18.035v35.325h-18.035z",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.917 296.588h18.036v31.433h-18.036z",
    fill: "#00c988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.316 265.827h18.035v30.761h-18.035z",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.992 185.78c-3.103 0-6.118.365-9.018 1.033 17.759 4.092 31.006 19.989 31.006 38.991s-13.246 34.899-31.006 38.991c2.9.668 5.915 1.033 9.018 1.033 22.104 0 40.024-17.919 40.024-40.024s-17.92-40.024-40.024-40.024z",
    fill: "#f3155e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.172 328.021h114.719v35.325h-114.719z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.571 296.588h85.922v31.433h-85.922z",
    fill: "#00e0a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.172 265.827h114.719v30.761h-114.719z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.532,
    cy: 225.803,
    fill: "#ff2f6b",
    rx: 40.024,
    ry: 40.024,
    transform: "matrix(.383 -.924 .924 .383 -142.234 238.738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.856 328.021h18.036v35.325h-18.036z",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.457 296.588h18.036v31.433h-18.036z",
    fill: "#00c988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.856 265.827h18.036v30.761h-18.036z",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.532 185.78c-3.103 0-6.118.365-9.018 1.033 17.759 4.092 31.006 19.989 31.006 38.991s-13.246 34.899-31.006 38.991c2.9.668 5.915 1.033 9.018 1.033 22.104 0 40.024-17.919 40.024-40.024-.001-22.105-17.92-40.024-40.024-40.024z",
    fill: "#f3155e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.976 415.892h-349.961c-33.217 0-62.759-21.117-73.509-52.546h496.98c-10.752 31.429-40.294 52.546-73.51 52.546z",
    fill: "#e8834d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.432 363.346c-10.751 31.429-40.293 52.546-73.509 52.546h27.053c33.217 0 62.759-21.117 73.509-52.546z",
    fill: "#d56723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.599 358.975c-1.411-1.974-3.687-3.145-6.114-3.145h-35.152v-27.81c0-4.15-3.365-7.515-7.515-7.515h-6.884v-16.403h6.884c4.15 0 7.515-3.365 7.515-7.515v-30.761c0-4.15-3.365-7.515-7.515-7.515h-22.721c7.991-8.509 12.9-19.943 12.9-32.509 0-23.656-17.37-43.325-40.024-46.939v-82.755c0-4.15-3.365-7.515-7.515-7.515s-7.515 3.365-7.515 7.515v82.749c-10.073 1.586-19.319 6.349-26.576 13.815-2.893 2.976-2.825 7.734.151 10.626 2.976 2.893 7.734 2.825 10.626-.151 6.078-6.252 14.193-9.732 22.891-9.842.141.008.28.021.423.021.142 0 .28-.013.419-.021 17.732.226 32.09 14.713 32.09 32.498 0 17.925-14.583 32.509-32.509 32.509-17.925 0-32.509-14.583-32.509-32.509 0-4.15-3.365-7.515-7.515-7.515s-7.515 3.364-7.515 7.515c0 12.566 4.909 24 12.9 32.509h-22.721c-4.15 0-7.515 3.365-7.515 7.515v30.761c0 4.15 3.365 7.515 7.515 7.515h6.884v16.403h-6.884c-4.15 0-7.515 3.365-7.515 7.515v27.81h-18.718v-27.81c0-4.15-3.365-7.515-7.515-7.515h-6.884v-16.403h6.884c4.15 0 7.515-3.365 7.515-7.515v-30.761c0-4.15-3.365-7.515-7.515-7.515h-22.72c7.991-8.509 12.9-19.943 12.9-32.509 0-23.656-17.37-43.325-40.024-46.939v-82.756c0-4.15-3.365-7.515-7.515-7.515s-7.515 3.365-7.515 7.515v82.756c-22.654 3.614-40.024 23.283-40.024 46.939 0 12.566 4.91 24 12.9 32.509h-22.721c-4.15 0-7.515 3.365-7.515 7.515v30.761c0 4.15 3.365 7.515 7.515 7.515h6.884v16.403h-6.884c-4.15 0-7.515 3.365-7.515 7.515v27.81h-18.711v-27.81c0-4.15-3.365-7.515-7.515-7.515h-6.884v-16.403h6.884c4.15 0 7.515-3.365 7.515-7.515v-30.761c0-4.15-3.365-7.515-7.515-7.515h-22.72c7.99-8.509 12.9-19.943 12.9-32.509 0-23.656-17.369-43.325-40.023-46.939v-82.756c0-4.15-3.365-7.515-7.515-7.515s-7.515 3.365-7.515 7.515v82.756c-22.654 3.614-40.024 23.283-40.024 46.939 0 12.566 4.909 24 12.9 32.509h-22.721c-4.15 0-7.515 3.365-7.515 7.515v30.761c0 4.15 3.365 7.515 7.515 7.515h6.884v16.403h-6.884c-4.15 0-7.515 3.365-7.515 7.515v27.81h-35.152c-5.064 0-8.753 5.147-7.11 9.947 11.791 34.47 44.189 57.629 80.619 57.629h236.026c4.15 0 7.515-3.365 7.515-7.515s-3.365-7.515-7.515-7.515h-236.025c-26.347 0-50.135-14.709-62.117-37.517h474.195c-11.982 22.808-35.77 37.516-62.117 37.516h-83.877c-4.15 0-7.515 3.365-7.515 7.515s3.365 7.515 7.515 7.515h83.877c36.43 0 68.828-23.159 80.619-57.629.786-2.295.414-4.828-.996-6.802zm-155.985-85.633h99.69v15.732h-99.69zm14.399 30.761h70.892v16.403h-70.892zm-14.399 31.433h99.69v20.295h-99.69zm-131.131-109.733c0-17.785 14.357-32.272 32.09-32.498.14.008.278.021.419.021.142 0 .28-.013.419-.021 17.732.226 32.09 14.713 32.09 32.498 0 17.925-14.583 32.509-32.509 32.509s-32.509-14.583-32.509-32.509zm-17.336 47.539h99.69v15.732h-99.69zm14.399 30.761h70.892v16.403h-70.892zm-14.399 31.433h99.69v20.295h-99.69zm-131.124-109.733c0-17.785 14.357-32.272 32.09-32.498.14.008.278.021.419.021s.28-.013.419-.021c17.732.226 32.089 14.713 32.089 32.498 0 17.925-14.583 32.509-32.508 32.509-17.926 0-32.509-14.583-32.509-32.509zm-2.937 78.3h20.416c4.15 0 7.515-3.365 7.515-7.515s-3.365-7.515-7.515-7.515h-34.815v-15.732h99.69v15.732h-34.815c-4.15 0-7.515 3.365-7.515 7.515s3.365 7.515 7.515 7.515h20.416v16.403h-70.892zm-14.399 31.433h99.69v20.295h-99.69z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg001Appetizer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/001-appetizer.193754d5.svg";
export { ForwardRef as ReactComponent };